<template>
  <b-card>
    <div>
      <div class="row">
        <b-form-group label="Location Type" label-for="location-type" class="col-lg-12">
          <b-select v-model="informationSource._type" id="location-type" name="location-type"
            v-validate="{ required: true }" :state="validateState('informationSource._type')">
            <option :value="null" selected>Select a Type</option>
            <option value="DMO">DMO</option>
            <option value="Organization">Organization</option>
            <option value="VisitorCenter">Visitor Center</option>
          </b-select>
          <div class="red"><font-awesome-icon v-if="veeErrors.first('location-type')" icon="exclamation-circle" size="1x"
              style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('location-type') }}</div>
        </b-form-group>
      </div>

      <div class="row">
        <TelephoneInput label="Telephone" id="phone" name="phone" v-model="informationSource.phone" @change="onChange"
          class="phone-group col-lg-3" />

        <!-- <b-form-group label="Telephone" label-for="phone" class="phone-group col-lg-3">
          <b-form-input type="tel" id="phone" name="phone" v-mask="'(###) ###-####'" @input="dirty=true" v-model="informationSource.phone" @change="onChange" />
        </b-form-group> -->

        <b-form-group label="Hours Of Operation" label-for="hoursOfOperation" class="col-lg-3">
          <b-form-input id="hours" name="hours" v-model="informationSource.hoursOfOperation" @change="onChange"
            v-validate="{ required: true }" :state="validateState('informationSource.hoursOfOperation')" />
          <div class="red"><font-awesome-icon v-if="veeErrors.first('hours')" icon="exclamation-circle" size="1x"
              style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('hours') }}</div>
        </b-form-group>
      </div>

    </div>
  </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import TelephoneInput from '../../../components/TelephoneInput.vue';

export default {
  components: {
    TelephoneInput,
  },
  data() {
    return {
      informationSource: {
        hoursOfOperation: {},
        phone: '',
      },
      submitted: false,
    };
  },
  props: ['value'],
  validations: {
    informationSource: {
      hoursOfOperation: {
        required,
      },
    },
  },
  mounted() {
    this.informationSource = this.value;
  },
  methods: {
    onChange() {
      this.$emit('input', this.informationSource);
      this.$emit('change', this.informationSource);
    },
    validate() {
      this.submitted = true;
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
  },
};
</script>

<style>
.phone-group {
  width: 300px;
}

.red {
  color: red;
}
</style>
